import { render, staticRenderFns } from "./trainingCalendar.vue?vue&type=template&id=2a49f17d&scoped=true"
import script from "./trainingCalendar.vue?vue&type=script&lang=js"
export * from "./trainingCalendar.vue?vue&type=script&lang=js"
import style0 from "./trainingCalendar.vue?vue&type=style&index=0&id=2a49f17d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a49f17d",
  null
  
)

export default component.exports